import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Container, TextField, Button, Typography, Box, CircularProgress } from "@mui/material";
import { getFunctions, httpsCallable } from "firebase/functions";

export default function AcceptInvitationPage() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchParams] = useSearchParams();
  const organizationId = searchParams.get("organizationId");
  const token = searchParams.get("token");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setMessage("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setIsSubmitting(true);
    const functions = getFunctions();
    const acceptInvitation = httpsCallable(functions, 'acceptInvitation');
    try {
      const result = await acceptInvitation({ organizationId, token, name, password });
      console.log(result.data);
      // Handle successful invitation acceptance (e.g., redirect to login page)
      window.location.href = "/login";
    } catch (error) {
      console.error("Error accepting invitation:", error);
      setMessage("Error accepting invitation. Please try again.");
    }
    setIsSubmitting(false);
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>Complete Your Sign-Up</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Name"
            margin="normal"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            margin="normal"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            fullWidth
            label="Confirm Password"
            type="password"
            margin="normal"
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}

          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isSubmitting}
            fullWidth
            sx={{ mt: 2 }}
          >
            {isSubmitting ? (<CircularProgress />) : ("Join")}
          </Button>
        </form>
        <Typography color="error" variant="body1" sx={{ mt: 2, textAlign: 'center' }}>
          {message}
        </Typography>
      </Box>
    </Container>
  );
}
